import { ChangeDetectionStrategy, Component, inject, DestroyRef } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { toSignal, takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SmsComponent } from '../sms/sms.component';
import {
  SMS_DEFAULT_MESSAGE_BY_LANG_CODE,
  SMS_LANGS,
  SMSLangCode,
} from '@eagle/app/shared/constants';
import { startWith } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { AuthService, OfficeRelation } from '@eagle/app/shared';

@Component({
  selector: 'wlnob-sms-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, TranslateModule, SmsComponent, MatSelectModule],
  templateUrl: './sms-dialog.component.html',
  styleUrls: ['./sms-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsDialogComponent {
  private readonly destroyRef = inject(DestroyRef);

  dialogRef = inject<MatDialogRef<SmsDialogComponent>>(MatDialogRef);

  private readonly authService = inject(AuthService);

  readonly smsLangs = SMS_LANGS;
  readonly langCodeControl = new FormControl<SMSLangCode>('nl');
  readonly messageControl = new FormControl<string>('');
  private readonly currUser = toSignal(this.authService.currentUser$);

  constructor() {
    const consultantPrimaryOffice = this.currUser()?.offices.find(
      office => office.userOfficeRelation === OfficeRelation.PRIMARY
    );

    this.langCodeControl.valueChanges
      .pipe(startWith(this.langCodeControl.value), takeUntilDestroyed(this.destroyRef))
      .subscribe(langCode =>
        this.messageControl.setValue(
          SMS_DEFAULT_MESSAGE_BY_LANG_CODE[langCode](consultantPrimaryOffice?.telephoneNumber)
        )
      );
  }
}
